export enum InvitationStatus {
  NotSent,
  Queued,
  SendFailure,
  Sent
}
